import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';
import { isUpdatePasswordSuccessResponse } from './userIdentity';

import Identity from './identity';
import { headers, logPrefix } from './constants';

/**
 * Update current user's password
 *
 * @param oldPassword
 * @param newPassword
 *
 * @returns
 * A __Promise__ which resolves to to `true` if successful.
 *
 * <details>
 * <summary>
 * On errors (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Registration/resetPassword
 * ```
 * </details>
 */

export default async function updatePassword(
  oldPassword: string,
  newPassword: string
): Promise<boolean | APIErrorResponse> {
  const isLoggedIn = await Identity.isLoggedIn();
  if (!isLoggedIn) {
    throw new Error(`${logPrefix} Missing or invalid jwt`);
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v1/password`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
      ...headers
    },
    body: JSON.stringify({ oldPassword, newPassword })
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isUpdatePasswordSuccessResponse(json)) {
        return true;
      } else {
        throw json;
      }
    });
}
